import React from "react";
import "./disclaimer.css";
import Footer from '../Components/Footer';
const disclaimer = () => {
    return (
        <div>
            <main className="disclaimer-page">

                <section className="disclaimer-hero">
                    <div className="container">
                        <h1>Disclaimer</h1>
                        <p className="last-updated">
                            Last updated: 01/08/2026
                        </p>
                    </div>
                </section>

                <section className="disclaimer-content">
                    <div className="container">

                        <p className="intro">
                            This Disclaimer applies to{" "}
                            <strong>https://digidzn.com</strong> and all content published by{" "}
                            <strong>DIGIDZN</strong> trading as <strong>digiDZN</strong>,
                            including blog posts, guides, case studies, location pages,
                            social media content, videos, webinars and downloadable resources.
                        </p>

                        <div className="disclaimer-section">
                            <h2>1. General information only</h2>

                            <p>
                                Content on this Website is for general informational and
                                educational purposes. It does not constitute professional advice
                                — legal, financial, tax, accounting or otherwise — and should
                                not be relied on as a substitute for advice from a qualified
                                professional who understands your specific circumstances.
                            </p>

                            <p>
                                We make reasonable efforts to keep content accurate and current,
                                but make no representation or warranty of any kind, express or
                                implied, as to accuracy, completeness, reliability, suitability
                                or availability. Digital marketing changes constantly; a tactic
                                or platform feature described in an article may be outdated by
                                the time you read it.{" "}
                                <strong>
                                    Any reliance you place on this content is strictly at your
                                    own risk.
                                </strong>
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>2. No guarantee of results</h2>

                            <p>
                                Digital marketing outcomes vary enormously between businesses.
                                Results depend on factors including your industry, market
                                maturity, competition, product-market fit, pricing, budget,
                                website quality, sales follow-up, seasonality, brand equity,
                                and the constantly changing algorithms and policies of platforms
                                such as Google, Meta, LinkedIn and Amazon.
                            </p>

                            <p>
                                <strong>digiDZN does not guarantee</strong> any specific search
                                ranking, volume of traffic, number of leads, conversion rate,
                                cost per acquisition, return on ad spend, revenue or profit.
                                Any figures, forecasts or projections shared in proposals,
                                articles or presentations are illustrative estimates based on
                                available data, not promises.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>3. Case studies and testimonials</h2>

                            <p>
                                Case studies, results and client testimonials on this Website
                                reflect the experience of specific clients in specific
                                conditions.{" "}
                                <strong>
                                    They are not typical, average, or guaranteed, and should not
                                    be taken as a representation of the results you will achieve.
                                </strong>{" "}
                                Where figures are shown, they relate to the stated campaign
                                period and the stated scope only.
                            </p>

                            <p>
                                Testimonials are genuine and shared with client permission.
                                Some may be edited for length or clarity without changing their
                                meaning. Client names or figures may be withheld or anonymised
                                where confidentiality requires it.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>4. Third-party platforms and tools</h2>

                            <p>
                                We reference and work with third-party platforms and tools
                                (Google, Meta, LinkedIn, YouTube, WhatsApp, analytics and
                                automation software, and others). We are independent of these
                                companies unless we expressly state a certification or
                                partnership status.
                            </p>

                            <p>
                                We have no control over their features, pricing, terms,
                                policies, algorithms, availability or account decisions —
                                including ad disapprovals, account suspensions, algorithm
                                updates or ranking changes.{" "}
                                <strong>
                                    We are not liable for losses arising from a third-party
                                    platform's actions, outages or policy changes.
                                </strong>
                            </p>

                            <p>
                                Trade marks, logos and brand names of third parties appearing
                                on this Website belong to their respective owners and are used
                                for identification and descriptive purposes only. Their
                                appearance does not imply endorsement of digiDZN by those
                                owners, or of them by us.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>5. External links</h2>

                            <p>
                                This Website contains links to external sites we do not control.
                                We do not endorse and are not responsible for their content,
                                accuracy, products, services, or privacy and security practices.
                                Visiting them is at your own risk.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>6. Affiliate and sponsored content</h2>

                            <p>
                                Some content may contain affiliate links or refer to tools with
                                which we have a commercial relationship. Where that is the case,
                                we will disclose it clearly on the relevant page. An affiliate
                                relationship never changes our editorial view — we only recommend
                                tools we would use ourselves. Purchasing through such a link
                                costs you nothing extra.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>7. AI-assisted content</h2>

                            <p>
                                Some content on this Website may be produced with the assistance
                                of AI tools, always subject to human review and editing before
                                publication. We take responsibility for what we publish, but
                                AI-assisted content may still contain errors — please verify
                                anything important before acting on it.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>8. Views and opinions</h2>

                            <p>
                                Views expressed in blog posts, guest posts and social content
                                are those of the author at the time of writing and do not
                                necessarily reflect the official position of digiDZN, its
                                clients or its partners.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>9. Limitation of liability</h2>

                            <p>
                                To the maximum extent permitted by law, digiDZN and its
                                personnel accept no liability for any loss or damage — direct,
                                indirect, incidental, consequential or otherwise, including
                                loss of profits, revenue, data or goodwill — arising from your
                                use of, or reliance on, this Website or its content.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>10. Errors and corrections</h2>

                            <p>
                                We correct errors as soon as we become aware of them. If you
                                spot something inaccurate, please write to{" "}
                                <a href="mailto:admin@digidzn.com">
                                    admin@digidzn.com
                                </a>{" "}
                                and we will review it.
                            </p>
                        </div>

                        <div className="disclaimer-section">
                            <h2>11. Contact</h2>

                            <div className="contact-box">
                                <p>
                                    <strong>DIGIDZN (digiDZN)</strong>
                                </p>

                                <p>
                                    A-169, Ashok Vihar, phase -1,
                                    <br />
                                    New Delhi - 110052
                                </p>

                                <p>
                                    Email:{" "}
                                    <a href="mailto:admin@digidzn.com">
                                        admin@digidzn.com
                                    </a>
                                </p>

                                <p>
                                    Phone:{" "}
                                    <a href="tel:+919289745760">
                                        +91 9289745760
                                    </a>
                                </p>
                            </div>
                        </div>

                    </div>
                </section>


            </main>
            <Footer />
        </div>
    );
};

export default disclaimer;